import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Header } from './components/Header'
import { Tabs } from 'components/Tabs'
import MaterialTable from "@material-table/core";
import Spinner from 'components/Spinner'
// import TablePaginationDemo from 'components/Paginator'
import { withTranslation } from 'react-i18next'
import useSWR from 'swr';
import { useEffect } from 'react';
import { BsChevronRight } from 'react-icons/bs';
import { previewModal } from 'store/slices/miscSlice';
import PreviewCustomers from './components/PreviewCustomer';
import { useDispatch } from 'react-redux';

export default withTranslation()(function Customer({ t }) {
  const { type } = useParams()
  const navigate = useNavigate()
    const dispatch = useDispatch()
  const { data } = useSWR('dashboard/loyalty-metrics-with-customers')

  const customers = ['total_customers', 'new_customers', 'returning_customers', 'inactive_customers']
  const [selected, setSelected] = useState(type ? type : 'total_customers')

  const [tableData, setTableData] = useState([])
  const columns = [
    { title: t('customers.table.name'), field: 'full_name' },
    { title: t('customers.table.email'), field: 'email' },
    { title: t('customers.table.phone'), field: 'phone' },
    { title: t('customers.table.visits'), field: 'total_visits', render: (data) => <p className='pl-[40px]'>{data?.total_visits || 0}</p> },
    { title: t('customers.table.itemPurchased'), field: 'total_phone', render: (data) => <p className='pl-[40px]'>{data?.total_phone || 0}</p> },
    { title: t('customers.table.ave'), field: 'average_spent', render: (data) => <p className='pl-[40px]'>{data?.average_spent || 0}</p> }
  ]
  let backend = data?.data;
  useEffect(() => {
    navigate(`/customers/${selected}`)
    if (backend) setTableData(Object.values(backend[selected]?.customers))
    // if (backend) console.log(Object.values(backend[selected]?.customers))
  }, [selected, navigate, backend])
  return (
    <div className='h-[50vh] bg-white p-5 rounded-[16px] '
    >
      <Header />

      <div className='flex my-3 border-b' style={{ boxSizing: 'border-box' }} >
        {customers.map(customer => <Tabs
          name={`${customer.replace('_customers', '')} (${backend ? backend[customer]?.count : 'loading'})`}
          onClick={() => setSelected(customer)}
          on={type === customer}
        />)}
      </div>
      {
        data ? <MaterialTable
          columns={columns}
          actions={[
            {
              icon: () => <BsChevronRight />,
              tooltip: 'Save User',
            },
          ]}
          localization={{
            header: {
              actions: "",
            },
            body: {
              emptyDataSourceMessage: <div className='py-[50px]'>  No customers to display </div>
            }
          }}
          options={{
            actionsColumnIndex: -1,
            headerStyle: {
              color: "#657585",
              fontWeight: 700,
              fontFamily: 'Helvetica Neue',
              lineHeight: '21px',
              fontSize: '14px'
            },
            actionsCellStyle: { width: '10px' },
            search: false,
            toolbar: false,
            // pageSize: misc.per_page,
            emptyRowsWhenPaging: false
          }}
          data={tableData}
          onRowClick={(_, data) => {
            dispatch(previewModal({
              title: `${t('customers.customerModalTitle')}`,
              content: () => <PreviewCustomers tableProps={data} />
            }))
          }}
          components={{
            // Action: ({ data }) => (
            //   <ViewMoreBtn click={() => {
            //     dispatch(previewModal({
            //       title: `${t('transaction.preview_title')}`,
            //       content: () => <PreviewTransaction tableProps={data} />
            //     }))
            //   }} />
            // ),
            // Pagination: ({ data }) => (<TablePaginationDemo />)
          }}
        /> : <Spinner />
      }
    </div>
  )
}
)
